import { z } from 'zod'

export function makePaginatedResponse<T extends z.ZodTypeAny>(schema: T) {
    return z.object({
        count: z.number(),
        next: z.string().nullable(),
        previous: z.string().nullable(),
        results: z.array(schema),
    })
}

export type InferPaginatedResponse<T extends ReturnType<typeof makePaginatedResponse>> = z.infer<T>
